import { assign } from '../common/utils';

const initialState = {
    cinemaList: []
}

const relatedCinema = (state = initialState, action) => {
    switch (action.type) {
        case 'cinema_change':
            return assign(state, {
                cinemaList: action.cinemaList
            });
        
        default:
            return state;
    }
};

export default relatedCinema;